import Vue from 'vue';
import Vuex from 'vuex';
import serviceCapacity from './modules/service-capacity';
import modelE from './modules/model-e';
import recall from './modules/recall';
import recallQuestions from './modules/recall-questions';
import universal from './modules/universal';
import reports from './modules/reports';
import validation from './modules/validation';
import actionPlanSurvey from './modules/action_plan_survey';
import retailTrafficAssessment from './modules/retail-traffic-assessment';
import bayCountsAssessment from './modules/bay-counts-assessment';
import vcu from './modules/vcu';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    serviceCapacity,
    modelE,
    recall,
    recallQuestions,
    universal,
    reports,
    validation,
    actionPlanSurvey,
    retailTrafficAssessment,
    bayCountsAssessment,
    vcu,
  },
});
